import { Trash2 } from "lucide-react";
import DeterminationBadge from "../../components/DeterminationBadge";
import { formatTime } from "../../lib/format";
import { statusTextColor } from "../../lib/constants";

function HistoryRow({ r, onDelete }) {
  return (
    <tr
      data-testid={`history-row-${r.id}`}
      className="border-t border-border/60 hover:bg-[#F9F9F8]"
    >
      <td className="px-4 py-3 text-[#5B695E] whitespace-nowrap">{formatTime(r.searched_at)}</td>
      <td className="px-4 py-3 font-mono text-xs">{r.normalized_parcel_id || r.parcel_id}</td>
      <td className="px-4 py-3">
        <span className={`text-xs font-medium ${statusTextColor(r.status)}`}>
          {(r.status || "").replace("_", " ")}
        </span>
      </td>
      <td className="px-4 py-3">
        {r.determination_code ? (
          <DeterminationBadge code={r.determination_code} />
        ) : (
          <span className="text-[#5B695E]">—</span>
        )}
      </td>
      <td className="px-4 py-3 text-[#111812]">{r.address || "—"}</td>
      <td className="px-4 py-3 font-mono text-xs text-[#5B695E]">{r.range_slug || "—"}</td>
      <td className="px-4 py-3 text-right">
        <button
          data-testid={`history-delete-${r.id}`}
          onClick={() => onDelete(r.id)}
          className="text-[#5B695E] hover:text-[#EF4444] transition-colors"
          aria-label="Delete entry"
        >
          <Trash2 className="h-4 w-4" strokeWidth={1.5} />
        </button>
      </td>
    </tr>
  );
}

export default function HistoryTable({ items, onDelete }) {
  return (
    <div className="bg-white border border-border/60 rounded-2xl shadow-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="history-table">
          <thead className="bg-[#F4F5F4] text-[#5B695E]">
            <tr>
              <th className="text-left px-4 py-3 font-medium">When</th>
              <th className="text-left px-4 py-3 font-medium">Parcel</th>
              <th className="text-left px-4 py-3 font-medium">Status</th>
              <th className="text-left px-4 py-3 font-medium">Determination</th>
              <th className="text-left px-4 py-3 font-medium">Address</th>
              <th className="text-left px-4 py-3 font-medium">Range</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {items.map((r) => (
              <HistoryRow key={r.id} r={r} onDelete={onDelete} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
